import * as nativeComponentAPI from '../../../../api/nativeComponentAPI'
import VisibleComponent from "./VisibleComponent";
import NativeComponent from "../NativeComponent";
import * as nativeComponentListener from "../../../../api/nativeComponentListener";

const nativeComponentAbility = NativeComponent.nativeComponentAbility

export default class SubplayTemplateView extends VisibleComponent {
    constructor (options={}) {
        const action = nativeComponentAPI.createSubPlayTemplateView
        const {campaign, unitId, unitSetting, userId, reward} = options
        const createParams = {
            campaign,
            unitId,
            unitSetting,
            userId,
            reward,
        }
        console.log('创建SubplayTemplateView ：：：',createParams,options,action )
        super(action, {
            ...options,
            params: createParams
        })
        this.bindSubplayTemplateViewEvent()
        //this.preload()
    }

    bindSubplayTemplateViewEvent(){
        this.onLoad((data)=>{
            console.log(`SubplayTemplateView id:${this.getId()} onLoad`, data)
        })
        this.onCloseBtnClicked((data)=>{
            console.log(`SubplayTemplateView id:${this.getId()} onCloseBtnClicked`, data)
        })
        this.onPlayStart((data)=>{
            console.log(`SubplayTemplateView id:${this.getId()} onPlayStart`, data)
        })
        this.onPlayFailed((data)=>{
            console.log(`SubplayTemplateView id:${this.getId()} onPlayFailed`, data)
        })
        this.onPlayCompleted((data)=>{
            console.log(`SubplayTemplateView id:${this.getId()} onPlayCompleted`, data)
        })
        this.onEndcardShowSuccess((data)=>{
            console.log(`SubplayTemplateView id:${this.getId()} onEndcardShowSuccess`, data)
        })
        this.onClicked((data)=>{
            console.log(`SubplayTemplateView id:${this.getId()} onClicked`, data)
        })
        this.onDismissed((data)=>{
            console.log(`SubplayTemplateView id:${this.getId()} onDismissed`, data)
        })
    }

    /**
     * 加载URL
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    preload(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.preloadSubPlayTemplateView(_params)
    }

    /**
     * 加载URL
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    setInfo(campaigns) {
        const _params = this.getInvokeParams({campaigns})
        return nativeComponentAPI.setSubPlayTemplateInfo(_params)
    }




    //*****************************************--事件--******************************************//


    /**
     * web的渲染结果
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onLoad(onSuccess, onError) {
        'function' === typeof cb &&
        nativeComponentListener.onSubPlayTemplateViewLoad(this.getId(), function(data){
            if(data.result ===1 ){
                onSuccess.call(this, data)
            }else{
                onError.call(this, data)
            }
        })
    }

    /**
     * 通知H5 用户点击了关闭按钮
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onCloseBtnClicked(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onSubPlayTemplateViewCloseBtnClicked(this.getId(), cb)
    }

    /**
     * 组件 showsuccess （视频开始播放）时的回调
     *（原本给开发者的，现在给H5，H5决定是否给SDK）
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onPlayStart(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onSubPlayTemplateViewPlayStart(this.getId(), cb)
    }

    /**
     * 组件 showfailed （播放视频失败）时的回调
     *（原本给开发者的，现在给H5，H5决定是否给SDK）
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onPlayFailed(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onSubPlayTemplateViewPlayFailed(this.getId(), cb)
    }

    /**
     * 组件 playcompleted 时的回调
     *（原本给开发者的，现在给H5，H5决定是否给SDK）
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onPlayCompleted(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onSubPlayTemplateViewPlayCompleted(this.getId(), cb)
    }

    /**
     * 组件 endcardshowsuccess 时的回调
     *（原本给开发者的，现在给H5，H5决定是否给SDK）
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onEndcardShowSuccess(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onSubPlayTemplateViewEndcardShowSuccess(this.getId(), cb)
    }

    /**
     * 组件触发 clicked 时的回调
     *（原本给开发者的，现在给H5，H5决定是否给SDK）
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onClicked(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onSubPlayTemplateViewClicked(this.getId(), cb)
    }

    /**
     * 组件 dismissed 时的回调
     *（原本给开发者的，现在给H5，H5决定是否给SDK）
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onDismissed(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onSubPlayTemplateViewDismissed(this.getId(), cb)
    }

}